// "use client";

// import Image from "next/image";
// import Link from "next/link";
// import IconLeftCaret from "@/components/icons/icon-left-caret";
// import { useCart } from "@/lib/cart/useCart";
// import {
//   buildOrderPayloadFromCart,
//   createOrder,
// } from "@/lib/service/order.service";
// import { useState } from "react";
// import toast from "react-hot-toast";
// import { useRouter } from "next/navigation";

// export default function PlaceOrderPage() {
//   const router = useRouter();
//   const { lines, subtotal, vat, delivery, total, clearAll } = useCart();

//   const [buyer, setBuyer] = useState({
//     name: "",
//     contact: "",
//     road: "",
//     house: "",
//     notes: "",
//   });
//   const [placing, setPlacing] = useState(false);

//   const selected = lines.filter((l) => l.selected);

//   async function onSubmit(e: React.FormEvent) {
//     e.preventDefault();
//     if (selected.length === 0)
//       return toast.error("Please select at least one item in cart.");
//     if (!buyer.name.trim()) return toast.error("Name is required");
//     if (!buyer.contact.trim()) return toast.error("Contact number is required");
//     if (!buyer.road.trim() && !buyer.house.trim())
//       return toast.error("Address is required");

//     setPlacing(true);
//     const tid = toast.loading("Placing order...");

//     try {
//       const payload = buildOrderPayloadFromCart(
//         lines,
//         {
//           name: buyer.name.trim(),
//           contactNumber: buyer.contact.trim(),
//           fullAddress: [buyer.road, buyer.house].filter(Boolean).join(", "),
//           notes: buyer.notes.trim() || undefined,
//         },
//         { vatRatePct: 5, deliveryFlat: 100 }
//       );

//       const order = await createOrder(payload);
//       toast.success("Order placed successfully!", { id: tid });

//       clearAll();
//       router.push(`/success?order=${order.id}`);
//     } catch (err: unknown) {
//       const msg = err instanceof Error ? err.message : "Failed to place order";
//       toast.error(msg, { id: tid });
//       setPlacing(false);
//     }
//   }

//   return (
//     <main>
//       <section className="pb-10 pt-[100px] sm:py-[200px] xl:py-[120px]">
//         <div className="max-w-[calc(1280px+40px)] w-full mx-auto px-5">
//           <Link
//             href="/cart"
//             className="back_btn translate-y-[40px] sm:translate-y-[70px]"
//           >
//             <IconLeftCaret className="max-sm:w-[4.22px]" />
//             Back
//           </Link>

//           <div className="text-center">
//             <h1 className="text-[25px] sm:text-[33px] md:text-4xl 2xl:text-[45px] md:mb-5 sm:mb-2 text-old-lace font-young-serif">
//               Billing Address
//             </h1>
//             <p className="text-sm sm:text-base md:text-lg xl:text-xl 2xl:text-[22px] text-old-lace">
//               Fill this form to place your order
//             </p>
//           </div>

//           <div className="w-full flex flex-col lg:flex-row gap-2.5 md:gap-5 mt-8 md:mt-[52px]">
//             {/* Form */}
//             <div className="w-full lg:order-1 order-2">
//               <form
//                 onSubmit={onSubmit}
//                 className="grow text-[10px] sm:text-base px-3 md:px-7.5 py-5 lg:py-10 bg-pickled-bluewood rounded-[10px]"
//               >
//                 <h1 className="text-lg sm:text-[30px] font-medium text-white">
//                   Billing Details{" "}
//                   <span className="text-lg">(Cash on Delivery)</span>
//                 </h1>

//                 <div className="mt-5 flex flex-col gap-5">
//                   <div className="flex flex-col gap-4">
//                     <input
//                       className="billing_input"
//                       placeholder="Enter your name"
//                       value={buyer.name}
//                       onChange={(e) =>
//                         setBuyer({ ...buyer, name: e.target.value })
//                       }
//                     />
//                     <input
//                       className="billing_input"
//                       placeholder="Contact No."
//                       value={buyer.contact}
//                       onChange={(e) =>
//                         setBuyer({ ...buyer, contact: e.target.value })
//                       }
//                     />
//                   </div>

//                   <div>
//                     <h1 className="text-base sm:text-xl font-medium text-white mb-3">
//                       Address
//                     </h1>
//                     <div className="flex flex-col lg:flex-row gap-2.5">
//                       <input
//                         className="billing_input"
//                         placeholder="Road / Street"
//                         value={buyer.road}
//                         onChange={(e) =>
//                           setBuyer({ ...buyer, road: e.target.value })
//                         }
//                       />
//                       <input
//                         className="billing_input"
//                         placeholder="House / Flat No."
//                         value={buyer.house}
//                         onChange={(e) =>
//                           setBuyer({ ...buyer, house: e.target.value })
//                         }
//                       />
//                     </div>
//                   </div>

//                   <div>
//                     <h1 className="text-base sm:text-xl font-medium text-white mb-3">
//                       Order notes (optional)
//                     </h1>
//                     <textarea
//                       className="billing_input min-h-[118px]"
//                       placeholder="Notes about your order…"
//                       value={buyer.notes}
//                       onChange={(e) =>
//                         setBuyer({ ...buyer, notes: e.target.value })
//                       }
//                     />
//                   </div>

//                   <div className="pt-2">
//                     <button
//                       disabled={placing || selected.length === 0}
//                       className="cart_btn_gradient w-full h-[60px] md:h-[76px] text-[22px] font-medium bg-old-gold rounded-[15px] disabled:opacity-60"
//                     >
//                       {placing ? "Placing…" : "Place order"}
//                     </button>
//                   </div>
//                 </div>
//               </form>
//             </div>

//             {/* Summary */}
//             <div className="lg:order-2 order-1 lg:max-w-[414px] w-full font-inter">
//               <div className="w-full p-5 bg-pickled-bluewood rounded-[10px]">
//                 <div className="flex items-center justify-between">
//                   <h1 className="text-sm md:text-[22px] font-semibold">
//                     Order Summary
//                   </h1>
//                   <Link
//                     className="text-[15px] font-light text-white underline"
//                     href="/cart"
//                   >
//                     Edit
//                   </Link>
//                 </div>

//                 <div className="w-full h-[1px] bg-[#FDF2DE]/60 mt-3.5 md:mt-2 mb-1" />

//                 <div className="max-h-[386px] px-4 pb-2 space-y-3 overflow-y-auto hide-scrollbar">
//                   {selected.map((o) => (
//                     <div key={o.id} className="flex items-center gap-3.5">
//                       <div className="w-[95px] h-[107px] rounded-[5px] overflow-hidden">
//                         <Image
//                           src={o.imageUrl || "/imgs/cart-1.png"}
//                           alt={o.name}
//                           width={100}
//                           height={100}
//                           className="size-full object-cover"
//                         />
//                       </div>
//                       <div className="w-full">
//                         <h3 className="item_name max-sm:text-[22px]">
//                           {o.name}
//                         </h3>
//                         <p className="text-sm sm:text-base font-light text-old-lace my-1">
//                           ৳ {o.price.toFixed(2)}
//                         </p>
//                         <div className="w-full flex items-center justify-between">
//                           <p className="text-base sm:text-lg font-semibold text-old-lace">
//                             Qty: {o.quantity}
//                           </p>
//                           <p className="text-base sm:text-lg font-semibold text-old-lace">
//                             ৳ {(o.price * o.quantity).toFixed(2)}
//                           </p>
//                         </div>
//                       </div>
//                     </div>
//                   ))}
//                   {selected.length === 0 && (
//                     <p className="text-white/70">No items selected.</p>
//                   )}
//                 </div>

//                 <div className="w-full h-[1px] bg-[#FDF2DE]/60 my-3.5" />
//                 <SummaryRow label="Delivery fee" value={delivery()} />
//                 <SummaryRow label="VAT(5%)" value={vat()} />
//                 <div className="w-full h-[1px] bg-[#FDF2DE]/60 my-2 md:my-4" />
//                 <SummaryRow label="TOTAL" value={total()} strong />
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>
//     </main>
//   );
// }

// function SummaryRow({
//   label,
//   value,
//   strong = false,
// }: {
//   label: string;
//   value: number;
//   strong?: boolean;
// }) {
//   return (
//     <div className="flex items-center justify-between">
//       <h4
//         className={`text-xs md:text-lg text-white ${
//           strong ? "font-semibold" : ""
//         }`}
//       >
//         {label}
//       </h4>
//       <p
//         className={`text-xs md:text-lg ${strong ? "font-bold" : "font-medium"}`}
//       >
//         ৳ {value.toFixed(2)}
//       </p>
//     </div>
//   );
// }
"use client";

import Image from "next/image";
import Link from "next/link";
import IconLeftCaret from "@/components/icons/icon-left-caret";
import { useCart, DELIVERY_ZONES } from "@/lib/cart/useCart";
import {
  buildOrderPayloadFromCart,
  createOrder,
} from "@/lib/service/order.service";
import { useState } from "react";
import toast from "react-hot-toast";
import { useRouter } from "next/navigation";

export default function PlaceOrderPage() {
  const router = useRouter();
  const {
    lines,
    subtotal,
    vat,
    delivery,
    total,
    clearAll,
    zone,
    isDeliveryAvailable,
  } = useCart();

  const [buyer, setBuyer] = useState({
    name: "",
    contact: "",
    road: "",
    house: "",
    notes: "",
  });
  const [placing, setPlacing] = useState(false);

  const selected = lines.filter((l) => l.selected);
  const deliveryFee = delivery();
  const zoneLabel = DELIVERY_ZONES.find((z) => z.value === zone)?.label ?? "";

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    if (selected.length === 0)
      return toast.error("Please select at least one item in cart.");
    if (!zone || !isDeliveryAvailable)
      return toast.error("Please select a valid delivery area.");
    if (!buyer.name.trim()) return toast.error("Name is required");
    if (!buyer.contact.trim()) return toast.error("Contact number is required");
    if (!buyer.road.trim() && !buyer.house.trim())
      return toast.error("Address is required");

    setPlacing(true);
    const tid = toast.loading("Placing order...");

    try {
      const payload = buildOrderPayloadFromCart(
        lines,
        {
          name: buyer.name.trim(),
          contactNumber: buyer.contact.trim(),
          fullAddress: [buyer.road, buyer.house].filter(Boolean).join(", "),
          notes: buyer.notes.trim() || undefined,
        },
        { vatRatePct: 5, deliveryFlat: deliveryFee },
      );

      const order = await createOrder(payload);
      toast.success("Order placed successfully!", { id: tid });
      clearAll();
      router.push(`/success?order=${order.id}`);
    } catch (err: unknown) {
      const msg = err instanceof Error ? err.message : "Failed to place order";
      toast.error(msg, { id: tid });
      setPlacing(false);
    }
  }

  return (
    <main>
      <section className="pb-10 pt-[100px] sm:py-[200px] xl:py-[120px]">
        <div className="max-w-[calc(1280px+40px)] w-full mx-auto px-5">
          <Link
            href="/cart"
            className="back_btn translate-y-[40px] sm:translate-y-[70px]"
          >
            <IconLeftCaret className="max-sm:w-[4.22px]" />
            Back
          </Link>

          <div className="text-center">
            <h1 className="text-[25px] sm:text-[33px] md:text-4xl 2xl:text-[45px] md:mb-5 sm:mb-2 text-old-lace font-young-serif">
              Billing Address
            </h1>
            <p className="text-sm sm:text-base md:text-lg xl:text-xl 2xl:text-[22px] text-old-lace">
              Fill this form to place your order
            </p>
          </div>

          <div className="w-full flex flex-col lg:flex-row gap-2.5 md:gap-5 mt-8 md:mt-[52px]">
            {/* Form */}
            <div className="w-full lg:order-1 order-2">
              <form
                onSubmit={onSubmit}
                className="grow text-[10px] sm:text-base px-3 md:px-7.5 py-5 lg:py-10 bg-pickled-bluewood rounded-[10px]"
              >
                <h1 className="text-lg sm:text-[30px] font-medium text-white">
                  Billing Details{" "}
                  <span className="text-lg">(Cash on Delivery)</span>
                </h1>

                <div className="mt-5 flex flex-col gap-5">
                  <div className="flex flex-col gap-4">
                    <input
                      className="billing_input"
                      placeholder="Enter your name"
                      value={buyer.name}
                      onChange={(e) =>
                        setBuyer({ ...buyer, name: e.target.value })
                      }
                    />
                    <input
                      className="billing_input"
                      placeholder="Contact No."
                      value={buyer.contact}
                      onChange={(e) =>
                        setBuyer({ ...buyer, contact: e.target.value })
                      }
                    />
                  </div>

                  <div>
                    <h1 className="text-base sm:text-xl font-medium text-white mb-3">
                      Address
                    </h1>
                    <div className="flex flex-col lg:flex-row gap-2.5">
                      <input
                        className="billing_input"
                        placeholder="Road / Street"
                        value={buyer.road}
                        onChange={(e) =>
                          setBuyer({ ...buyer, road: e.target.value })
                        }
                      />
                      <input
                        className="billing_input"
                        placeholder="House / Flat No."
                        value={buyer.house}
                        onChange={(e) =>
                          setBuyer({ ...buyer, house: e.target.value })
                        }
                      />
                    </div>
                  </div>

                  <div>
                    <h1 className="text-base sm:text-xl font-medium text-white mb-3">
                      Order notes (optional)
                    </h1>
                    <textarea
                      className="billing_input min-h-[118px]"
                      placeholder="Notes about your order…"
                      value={buyer.notes}
                      onChange={(e) =>
                        setBuyer({ ...buyer, notes: e.target.value })
                      }
                    />
                  </div>

                  <div className="pt-2">
                    <button
                      disabled={
                        placing || selected.length === 0 || !isDeliveryAvailable
                      }
                      className="cart_btn_gradient w-full h-[60px] md:h-[76px] text-[22px] font-medium bg-old-gold rounded-[15px] disabled:opacity-60"
                    >
                      {placing ? "Placing…" : "Place order"}
                    </button>
                  </div>
                </div>
              </form>
            </div>

            {/* Summary */}
            <div className="lg:order-2 order-1 lg:max-w-[414px] w-full font-inter">
              <div className="w-full p-5 bg-pickled-bluewood rounded-[10px]">
                <div className="flex items-center justify-between">
                  <h1 className="text-sm md:text-[22px] font-semibold">
                    Order Summary
                  </h1>
                  <Link
                    className="text-[15px] font-light text-white underline"
                    href="/cart"
                  >
                    Edit
                  </Link>
                </div>

                {/* Zone badge */}
                {zoneLabel && (
                  <div className="mt-2 mb-1 text-xs md:text-sm text-white/70">
                    📍 Delivering to:{" "}
                    <span className="text-white font-medium">{zoneLabel}</span>
                  </div>
                )}

                <div className="w-full h-[1px] bg-[#FDF2DE]/60 mt-3.5 md:mt-2 mb-1" />

                <div className="max-h-[386px] px-4 pb-2 space-y-3 overflow-y-auto hide-scrollbar">
                  {selected.map((o) => (
                    <div key={o.id} className="flex items-center gap-3.5">
                      <div className="w-[95px] h-[107px] rounded-[5px] overflow-hidden">
                        <Image
                          src={o.imageUrl || "/imgs/cart-1.png"}
                          alt={o.name}
                          width={100}
                          height={100}
                          className="size-full object-cover"
                        />
                      </div>
                      <div className="w-full">
                        <h3 className="item_name max-sm:text-[22px]">
                          {o.name}
                        </h3>
                        <p className="text-sm sm:text-base font-light text-old-lace my-1">
                          ৳ {o.price.toFixed(2)}
                        </p>
                        <div className="w-full flex items-center justify-between">
                          <p className="text-base sm:text-lg font-semibold text-old-lace">
                            Qty: {o.quantity}
                          </p>
                          <p className="text-base sm:text-lg font-semibold text-old-lace">
                            ৳ {(o.price * o.quantity).toFixed(2)}
                          </p>
                        </div>
                      </div>
                    </div>
                  ))}
                  {selected.length === 0 && (
                    <p className="text-white/70">No items selected.</p>
                  )}
                </div>

                <div className="w-full h-[1px] bg-[#FDF2DE]/60 my-3.5" />
                <SummaryRow label="Delivery fee" value={deliveryFee} />
                <SummaryRow label="VAT(5%)" value={vat()} />
                <div className="w-full h-[1px] bg-[#FDF2DE]/60 my-2 md:my-4" />
                <SummaryRow label="TOTAL" value={total()} strong />
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}

function SummaryRow({
  label,
  value,
  strong = false,
}: {
  label: string;
  value: number;
  strong?: boolean;
}) {
  return (
    <div className="flex items-center justify-between">
      <h4
        className={`text-xs md:text-lg text-white ${strong ? "font-semibold" : ""}`}
      >
        {label}
      </h4>
      <p
        className={`text-xs md:text-lg ${strong ? "font-bold" : "font-medium"}`}
      >
        ৳ {value.toFixed(2)}
      </p>
    </div>
  );
}
